if (!customElements.get('arvada-collection-navigation')) {
  customElements.define('arvada-collection-navigation', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.av-collection-track');
      this.controls = this.querySelector('.av-collection-controls');
      this.abort = new AbortController();
      this.update = () => {
        const items = [...this.track.children];
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const required = items.reduce((width, item) => width + item.getBoundingClientRect().width, 0) + Math.max(0, items.length - 1) * gap;
        const overflow = matchMedia(`(min-width: ${(parseInt(this.dataset.bp, 10) || 950) + 1}px)`).matches && required > this.clientWidth + 2;
        this.toggleAttribute('data-overflow', overflow);
        const picture = this.querySelector('.av-collection-picture');
        if (picture) this.style.setProperty('--av-picture-height', `${picture.getBoundingClientRect().height}px`);
        this.controls.hidden = !overflow;
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const position = Math.abs(this.track.scrollLeft);
        this.querySelector('[data-av-collection-step="-1"]').disabled = position <= 1;
        this.querySelector('[data-av-collection-step="1"]').disabled = position >= this.track.scrollWidth - this.track.clientWidth - 2;
        this.direction = rtl ? -1 : 1;
      };
      this.controls.addEventListener('click', event => {
        const button = event.target.closest('button[data-av-collection-step]');
        if (!button) return;
        this.track.scrollBy({ left: Number(button.dataset.avCollectionStep) * this.direction * this.track.clientWidth * .8, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }, { signal: this.abort.signal });
      this.track.addEventListener('scroll', this.update, { passive: true, signal: this.abort.signal });
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this);
      this.observer.observe(this.track);
      this.update();
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
  });
}

if (!customElements.get('arvada-sticky-filters')) {
  customElements.define('arvada-sticky-filters', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('collection-component');
      this.abort = new AbortController();
      this.headers = [...document.querySelectorAll('.section-header, .announcement-bar-section')];
      const update = () => {
        let top = 16;
        this.headers.forEach(header => {
          const style = getComputedStyle(header);
          const type = header.querySelector('sticky-header')?.getAttribute('data-sticky-type');
          if (!['sticky', 'fixed'].includes(style.position) && (!type || type === 'none')) return;
          const rect = header.getBoundingClientRect();
          if (style.visibility !== 'hidden' && rect.bottom > 0 && rect.top < innerHeight) top = Math.max(top, rect.bottom + 16);
        });
        this.root.style.setProperty('--av-filters-top', `${Math.ceil(top)}px`);
        this.frame = performance.now() < this.until ? requestAnimationFrame(update) : null;
      };
      const schedule = () => { if (this.frame == null) this.frame = requestAnimationFrame(update); };
      this.resize = new ResizeObserver(schedule);
      this.mutation = new MutationObserver(() => { this.until = performance.now() + 350; schedule(); });
      this.headers.forEach(header => { this.resize.observe(header); this.mutation.observe(header, { attributes: true, attributeFilter: ['class', 'style'] }); });
      addEventListener('scroll', schedule, { passive: true, signal: this.abort.signal });
      addEventListener('resize', schedule, { passive: true, signal: this.abort.signal });
      schedule();
    }
    disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); this.mutation?.disconnect(); cancelAnimationFrame(this.frame); }
  });
}
